import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './Activation.messages';
import { GlobalPublicState } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';
import { Redirect } from 'react-router';

export interface ActivationResendProps {
  activateUser: GlobalPublicState['activateUser'];
  dispatch: Function;
  email: string;
}

export interface ActivationResendState {
  requestSuccess: boolean;
}

export class ActivationResendPartial extends React.Component<ActivationResendProps, ActivationResendState> {
  constructor(props: ActivationResendProps) {
    super(props);

    this.state = {
      requestSuccess: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidUpdate(prevProps: ActivationResendProps) {
    const {
      activateUser
    } = this.props;
    
    const activateState = activateUser.result;
    const prevActivateState = prevProps.activateUser.result;

    if (activateUser.loaded && !activateUser.updating) {
      if (!prevActivateState && activateState && activateState.emailSend) {
        this.setState({requestSuccess: true});
      }
    }
  }

  public render() {
    const {
      activateUser
    } = this.props;

    return (
      <>
        <a 
          href="/resend-activation-link" 
          className={classNames({disabled: activateUser.updating})}
          onClick={this.handleClick}
        >
          <FormattedMessage {...MESSAGES.activationResend} />
        </a>
        {this.state.requestSuccess && (
          <Redirect to="/register/resend-activation/succeeded" />
        )}
      </>
    );
  }

  private handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();

    const {
      activateUser,
      email
    } = this.props;
    
    if (!email || email.length === 0 || activateUser.updating) {
      return;
    }

    this.props.dispatch(requestAPIActions.load(
      'activateUser',
      {
        url: '/Users/verify-account',
        options: {
          method: 'POST',
          data: {email: this.props.email}
        }
      }
    ));
  }
}

export const ActivationResend = connect((state: GlobalPublicState) => ({
    activateUser: state.activateUser,
  }))(ActivationResendPartial);

export default ActivationResend;

